export function getTabItems(key, label, icon, children) {
    return {key,label,children,icon,};
}


export function getTableItem(key, label, sort, setSort) {
    return { key, label, sort, setSort };
} 
